const customersLocationsColumns = {
  department: {
    key: 'department',
    label: 'department',
    type: 'enum',
    enum: 'laboratories',
    sortable: 'custom',
  },
  location: {
    key: 'location.name',
    label: 'location',
    type: 'text',
    sortable: 'custom',
    minWidth: 200,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    buttons: [
      {
        name: 'editCustomerLocation',
        icon: 'fas fa-pencil',
        permissions: ['locationCustomerDepartmentManage'],
      },
      {
        name: 'deleteCustomerLocation',
        icon: 'fas fa-trash-alt',
        permissions: ['locationCustomerDepartmentManage'],
      },
    ],
  },
};

export default customersLocationsColumns;
